import { normalizeLocationInfo } from '@utils/storeDataNormalization';
import statesModuleFactory from '@helpers/storeFactories/moduleFactory';
import { apiService } from '@api';
import statesWithHotels from './statesWithHotels';

const STORE_NAME = 'states';

const store = statesModuleFactory.createModuleView(
    STORE_NAME,
    apiService,
    { customListFormatter: normalizeLocationInfo },
    {
        modules: {
            statesWithHotels: statesWithHotels,
        },
    }
);

export default store;
